const API_KEY = "AIzaSyBXSiA_nDuAAipABL_qRVmdUrqmPN93nkE";

export default API_KEY;
